export const SUPPORT_EMAIL = 'support.insights@screeningeagle.com';
export const BAIDU_MAP_KEY = 'KYMWRrXQGZwKCr82MOjTGY7jmTbT6H6y';

export const CHINA_DOMAINS = new Set([
    // dev
    'pq-cn.tectusdreamlab.com',
    // stg
    'api-stg.proceq.screeningeagle.com.cn',
    'api-stg.proceq.screeningeagle.tech',
    // prod
    'api.proceq.screeningeagle.com.cn',
    'api.proceq.screeningeagle.tech',
]);

export const API_SCOPE = ['openid', 'email', 'profile', 'offline', 'sensor', 'sensor_common'].join(' ');
